import { createAction, props } from '@ngrx/store';
import { Avatar } from '../../models/avatar.model';

export const loadMenu = createAction(
  '[Menu] Load Menu'
);

export const setUserMenu = createAction('[Menu] Set User Menu', props<{ user: Avatar }>());
